import { useRef, useState, useContext } from 'react'
import Icon from '../../components/atomic/Icon'
import Link from 'next/link'
import SlickSlider from 'react-slick'
import { sendGTMData } from '../../utils/gtm'
import { useTrans } from 'hooks'
import { CartContext } from 'utils/context'

const handleGTM = (action, moreInfo) => {
  let data = {
    event: 'GAevent',
    eventID: '21',
    eventCategory: 'conversioni',
    eventAction: action,
    eventLabel: 'landing_io_plus',
  }
  if (moreInfo) data['moreInfo'] = moreInfo

  sendGTMData(data)
}

function IoPiu2Hero({ scrollRef }) {
  const t = useTrans()

  return (
    <div className="iopiu2-hero">
      <img
        src={'/images/iopiu2/cover.jpeg'}
        className="iopiu2-hero__image iopiu2-hero__image--desktop"
      />
      <img
        src={'/images/iopiu2/cover-mobile.jpeg'}
        className="iopiu2-hero__image iopiu2-hero__image--mobile"
      />
      <div className="iopiu2-hero__layer" />
      <div className="iopiu2-hero__content">
        <div className="iopiu2-hero__title">
          <p>{t('Un mondo di idee e materiali per la scuola')}</p>
        </div>
        <div className="iopiu2-hero__cta-box">
          <div
            className="button button--primary button--black button--inverted iopiu2-hero__cta"
            onClick={() => {
              handleGTM('scopri_io_plus')
              scrollRef?.current && scrollRef.current.scrollIntoView({ behavior: 'smooth' })
            }}
          >
            {t('Scopri io+')}
          </div>
        </div>
      </div>
    </div>
  )
}

function IoPiu2Options() {
  return (
    <div className="iopiu2-options">
      <div className="iopiu2-options__register">
        <p className="iopiu2-options__register__title">Unisciti a noi.</p>
        <p className="iopiu2-options__register__description">
          <b>Registrati su giuntiscuola.it</b> per accedere <b>gratuitamente</b> al tuo libro di
          testo digitale <b>Dbookeasy</b> e a <b>migliaia di contenuti</b> per star bene a scuola.
        </p>
        <div className="iopiu2-options__register__icons">
          <Icon id="logo-giuntiscuola-color--colored" />
          <Icon id="dbookeasy" />
        </div>
        <div className="iopiu2-options__register__cta-box">
          <Link legacyBehavior href="/registrazione">
            <a
              target="_blank"
              className="button button--primary button--black iopiu2-options__register__cta"
              onClick={() => handleGTM('registrazione_giuntiscuola')}
            >
              Registrati
            </a>
          </Link>
        </div>
      </div>
      <div className="iopiu2-options__trial">
        <p className="iopiu2-options__trial__title">Vuoi qualcosa di più?</p>
        <p className="iopiu2-options__trial__description">
          <span>
            <b>Abbonati a io+.</b>
          </span>
          Potrai accedere ai <b>contenuti premium</b> del sito, alle <b>riviste Giunti Scuola</b>,
          creare <b>raccolte personalizzate</b> e molto altro.
        </p>
        <div className="iopiu2-options__trial__icons">
          <Icon id="ioplus" />
        </div>
        <div className="iopiu2-options__trial__cta-box">
          <Link legacyBehavior href="/registrazione">
            <a
              target="_blank"
              className="button button--primary button--red iopiu2-options__trial__cta"
              onClick={() => handleGTM('diventa_membro_io_plus')}
            >
              Provalo gratis per 30 giorni!
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}

function IoPiu2Vantaggi() {
  const context = useContext(CartContext)

  const [activeTab, setActiveTab] = useState(2)

  const desktopItems = [
    { id: 1, labelDesktop: 'Accesso al tuo libro di testo digitale' },
    { id: 2, labelDesktop: 'Materiali didattici accessibili', values: true },
    { id: 3, labelDesktop: 'Accesso alla Community' },
    { id: 4, labelDesktop: 'Raccolte personalizzate' },
    { id: 5, labelDesktop: 'Pubblicazione articoli' },
    { id: 6, labelDesktop: 'Contatta un esperto' },
    { id: 7, labelDesktop: 'Scarica Lezioni e Materiali' },
    { id: 8, labelDesktop: 'Stampa Lezioni e Materiali' },
    { id: 9, labelDesktop: 'Riviste digitali' },
    { id: 10, labelDesktop: 'Rivista cartacea' },
  ]
  const mobileItems = [
    { id: 1, label: 'Accesso al libro digitale' },
    { id: 2, label: '1000+ materiali' },
    { id: 3, label: '35.000+ materiali' },
    { id: 4, label: 'Personalizza, scarica e stampa lezioni e materiali' },
    { id: 5, label: 'Contatta l’esperto' },
    { id: 6, label: 'Rivista digitale' },
    { id: 7, label: 'Rivista cartacea' },
  ]
  const options = [
    {
      id: 1,
      label: 'REGISTRATO<br />GIUNTISCUOLA.IT',
      desktopItems: [1, 2],
      desktopValues: [{ id: 2, value: '1000+' }],
      mobileItems: [1, 2],
      prezzoTitle: 'Gratis',
      prezzoDesc: 'Per sempre!',
      ctaLabel: 'Registrati',
      ctaRoute: '/registrazione',
      ctaGTM: 'registrazione_giuntiscuola',
      color: 'beige',
    },
    {
      id: 2,
      label: 'ABBONATO io+<br />E RIVISTA DIGITALE',
      desktopItems: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      desktopValues: [{ id: 2, value: '<b>35.000+</b>' }],
      mobileItems: [1, 2, 3, 4, 5, 6],
      prezzoTitle: '49,99 €*',
      prezzoDesc: 'Sono solo <b>4,2 €</b> al mese!',
      ctaLabel: 'Abbonati a io+',
      ctaGTM: 'io_plus_annuale',
      ctaOnClick: () => context.addAbbonamentoToCart(8),
      color: 'orange',
    },
    {
      id: 3,
      label: 'ABBONATO io+<br />E RIVISTA CARTACEA',
      desktopItems: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
      desktopValues: [{ id: 2, value: '<b>35.000+</b>' }],
      mobileItems: [1, 2, 3, 4, 5, 6, 7],
      prezzoTitle: '69,99 €*',
      prezzoDesc: 'Sono solo <b>5,8 €</b> al mese!',
      ctaLabel: 'Scopri di più',
      ctaRoute: '/riviste',
      ctaGTM: 'io_plus_annuale_rivista',
      color: 'red',
    },
  ]

  return (
    <div className="iopiu2-vantaggi">
      <p className="iopiu2-vantaggi__title">Perché abbonarsi a io+?</p>
      <p className="iopiu2-vantaggi__description">
        Scopri tutti i vantaggi che ti offre l'abbonamento!
      </p>
      <div className="iopiu2-vantaggi__tabs">
        <div className="iopiu2-vantaggi__tabs__triggers">
          {options.map((t, i) => (
            <div
              key={'vantaggitabtrigger-' + i}
              className={
                'iopiu2-vantaggi__tabs__trigger' +
                (activeTab === t.id ? ' iopiu2-vantaggi__tabs__trigger--active' : '')
              }
              onClick={() => setActiveTab(t.id)}
            >
              <span dangerouslySetInnerHTML={{ __html: t.label }}></span>
            </div>
          ))}
        </div>
        <div className="iopiu2-vantaggi__tabs__blocks">
          {options.map((t, i) => (
            <div
              key={'vantaggitab-' + i}
              className={
                'iopiu2-vantaggi__tab iopiu2-vantaggi__tab--' +
                t.color +
                (activeTab === t.id ? ' iopiu2-vantaggi__tab--active' : '')
              }
            >
              <p
                className="iopiu2-vantaggi__tab__title"
                dangerouslySetInnerHTML={{ __html: t.label }}
              ></p>
              <div className="iopiu2-vantaggi__tab__list">
                {t.mobileItems.map((id, j) => {
                  let item = mobileItems.find((x) => x.id === id)
                  return (
                    item && (
                      <p
                        className="iopiu2-vantaggi__tab__item"
                        key={'vantaggitabitem-' + i + '-' + j}
                      >
                        <Icon id="check" />
                        <span className="iopiu2-vantaggi__tab__item__label">{item.label}</span>
                      </p>
                    )
                  )
                })}
              </div>
              <div className="iopiu2-vantaggi__tab__price-title">{t.prezzoTitle}</div>
              <div
                className="iopiu2-vantaggi__tab__price-description"
                dangerouslySetInnerHTML={{ __html: t.prezzoDesc }}
              ></div>
              <div className="iopiu2-vantaggi__tab__cta-box">
                {t.ctaRoute ? (
                  <Link legacyBehavior href={t.ctaRoute}>
                    <a
                      target="_blank"
                      onClick={() => {
                        handleGTM(t.ctaGTM)
                        if (t.ctaOnClick) t.ctaOnClick()
                      }}
                      className={
                        'button button--primary button--' + t.color + ' iopiu2-vantaggi__tab__cta'
                      }
                    >
                      {t.ctaLabel}
                    </a>
                  </Link>
                ) : (
                  <a
                    target="_blank"
                    className={
                      'button button--primary button--' + t.color + ' iopiu2-vantaggi__tab__cta'
                    }
                    href={t.ctaExtLink}
                    onClick={() => {
                      handleGTM(t.ctaGTM)
                      if (t.ctaOnClick) t.ctaOnClick()
                    }}
                  >
                    {t.ctaLabel}
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="iopiu2-vantaggi__table">
        <div className="iopiu2-vantaggi__table__col iopiu2-vantaggi__table__col--main">
          {desktopItems.map((item, i) => (
            <div className="iopiu2-vantaggi__table__cell" key={'vantaggitable-' + i}>
              <span>{item.labelDesktop}</span>
            </div>
          ))}
          <div className="iopiu2-vantaggi__table__price">
            <p className="iopiu2-vantaggi__table__price__label">Prezzo</p>
          </div>
        </div>
        {options.map((t, i) => (
          <div
            className={'iopiu2-vantaggi__table__col iopiu2-vantaggi__table__col--' + t.color}
            key={'vantaggitablecol-' + i}
          >
            <div className="iopiu2-vantaggi__table__cell iopiu2-vantaggi__table__cell--head">
              <p
                className="iopiu2-vantaggi__table__col__title"
                dangerouslySetInnerHTML={{ __html: t.label }}
              ></p>
            </div>
            {desktopItems.map((item, j) => (
              <div
                className="iopiu2-vantaggi__table__cell"
                key={'vantaggitablecell-' + i + '-' + j}
              >
                {t.desktopItems.indexOf(item.id) > -1 &&
                  (item.values ? (
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t.desktopValues.find((x) => x.id === item.id)?.value,
                      }}
                    ></span>
                  ) : (
                    <Icon id="check" />
                  ))}
              </div>
            ))}
            <div className="iopiu2-vantaggi__table__price">
              <p className="iopiu2-vantaggi__table__price__title">{t.prezzoTitle}</p>
              <p
                className="iopiu2-vantaggi__table__price__description"
                dangerouslySetInnerHTML={{ __html: t.prezzoDesc }}
              ></p>
            </div>
            <div className="iopiu2-vantaggi__table__cta-box">
              {t.ctaRoute ? (
                <Link legacyBehavior href={t.ctaRoute}>
                  <a
                    target="_blank"
                    onClick={() => {
                      handleGTM(t.ctaGTM)
                      if (t.ctaOnClick) t.ctaOnClick()
                    }}
                    className={
                      'button button--primary button--' + t.color + ' iopiu2-vantaggi__table__cta'
                    }
                  >
                    {t.ctaLabel}
                  </a>
                </Link>
              ) : (
                <a
                  target="_blank"
                  className={
                    'button button--primary button--' + t.color + ' iopiu2-vantaggi__table__cta'
                  }
                  href={t.ctaExtLink}
                  onClick={() => {
                    handleGTM(t.ctaGTM)
                    if (t.ctaOnClick) t.ctaOnClick()
                  }}
                >
                  {t.ctaLabel}
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

function IoPiu2Numeri() {
  const items = [
    { numero: '13.000+', label: 'UTENTI GIORNALIERI' },
    { numero: '250+', label: "LEZIONI PRONTE ALL'USO" },
    { numero: '4700+', label: 'RACCOLTE' },
    { numero: '460+', label: 'CONTENUTI AUDIO E VIDEO ' },
    { numero: '13.000+', label: 'ARTICOLI' },
    { numero: '19.000+', label: 'MATERIALI' },
  ]
  const settings = {
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1065,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  }

  return (
    <div className="iopiu2-numeri">
      <div className="iopiu2-numeri__content">
        <p className="iopiu2-numeri__title">
          <span>Abbonati a io+: </span> un mondo di risorse e di contenuti ti aspetta.
        </p>
        <div className="iopiu2-numeri__slider">
          <SlickSlider {...settings}>
            {items.map((item, i) => (
              <div className="iopiu2-numeri__slide" key={'numeri-' + i}>
                <div className="iopiu2-numeri__item">
                  <div className="iopiu2-numeri__item__numero">{item.numero}</div>
                  <div className="iopiu2-numeri__item__label">{item.label}</div>
                </div>
              </div>
            ))}
          </SlickSlider>
        </div>
      </div>
    </div>
  )
}

function IoPiu2Video() {
  const [showMore, setShowMore] = useState(false)
  const items = [
    {
      cover: '/images/iopiu/cover_1.png',
      link: 'https://vimeo.com/showcase/7639835/video/465332618',
      gtmInfo: 'ambiente_digitale',
    },
    {
      cover: '/images/iopiu/cover_2.png',
      link: 'https://vimeo.com/showcase/7639835/video/465334039',
      gtmInfo: 'temi_e_raccolte',
    },
    {
      cover: '/images/iopiu/cover_3.png',
      link: 'https://vimeo.com/showcase/7639835/video/465333747',
      gtmInfo: 'ricerca_avanzata',
    },
    {
      cover: '/images/iopiu/cover_4.png',
      link: 'https://vimeo.com/showcase/7639835/video/465333594',
      gtmInfo: 'area_personale',
    },
  ]
  const sliderItems = items.map((v) => (
    <div className="iopiu2-video__slider__item" key={v.link}>
      <a href={v.link} target="_blank" onClick={() => handleGTM('video', v.gtmInfo)}>
        <img src={v.cover} />
        <img className="play" src={'/images/iopiu/play.png'} />
      </a>
    </div>
  ))

  let prev = useRef(null)
  let next = useRef(null)
  let slider = useRef(null)
  let container = useRef(null)

  const classOverlay = 'slider-container--overlay'

  const handleChange = (index = 0) => {
    if (index === 0) {
      container.classList.remove(classOverlay)
    } else {
      container.classList.add(classOverlay)
    }
  }

  const handleBeforeChange = (index = 0) => {
    if (index === 0) {
      container.classList.add(classOverlay)
    }
  }

  const handlePrev = () => {
    slider.slickPrev()
  }

  const handleNext = () => {
    slider.slickNext()
  }

  const settings = {
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    arrows: false,
    onSwipe: handleChange,
    beforeChange: handleBeforeChange,
    afterChange: handleChange,
  }

  return (
    <div className="iopiu2-video">
      <div className="iopiu2-video__title">Cosa rende unico l’abbonamento io+?</div>
      <div className="iopiu2-video__description">Te lo raccontano le insegnanti che lo usano!</div>
      <div className="iopiu2-video__slider">
        <div className="slider-container" ref={(self) => (container = self)}>
          <button
            className={`slider-nav-item slider-nav-item--prev button button--primary`}
            onClick={handlePrev}
            ref={(self) => (prev = self)}
            aria-label={'Precedente'}
          >
            <Icon id="chevron-sharp-right" />
          </button>
          <SlickSlider ref={(self) => (slider = self)} {...settings}>
            {sliderItems}
          </SlickSlider>
          <button
            className={`slider-nav-item slider-nav-item--next button button--primary`}
            onClick={handleNext}
            ref={(self) => (next = self)}
            aria-label={'Successivo'}
          >
            <Icon id="chevron-sharp-right" />
          </button>
        </div>
      </div>
      <div className="iopiu2-video__video w-container">
        <div className="iopiu2-video__video__first">{sliderItems.slice(0, 1)}</div>
        <div className={`iopiu2-video__video__others ${showMore ? 'show' : ''}`}>
          {sliderItems.slice(1, sliderItems.length)}
        </div>
        <div className="iopiu2-video__video__toggle" onClick={() => setShowMore(!showMore)}>
          {showMore ? (
            <>
              <Icon id="chevron-sharp-right" classes="hide" />
              <a>Mostra meno...</a>
            </>
          ) : (
            <>
              <span>Carica altri video...</span> <Icon id="chevron-sharp-right" />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

function IoPiu2Help() {
  const items = [
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
          <g>
            <path d="M39.54,13A26.51,26.51,0,1,0,66.05,39.51,26.54,26.54,0,0,0,39.54,13Zm0,48.22A21.71,21.71,0,1,1,61.25,39.51,21.73,21.73,0,0,1,39.54,61.22Z" />
            <path d="M86.26,82.9,63.09,59.73a2.4,2.4,0,0,0-3.39,3.39L82.87,86.29a2.4,2.4,0,1,0,3.39-3.39Z" />
          </g>
        </svg>
      ),
      title: 'Trovare',
      description:
        'il materiale per svolgere il tuo lavoro in classe o in sezione: materiali e lezioni per la scuola dell’infanzia e per tutte le discipline della scuola primaria.',
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
          <g>
            <path d="M83.16,23.91H16.84A13.89,13.89,0,0,0,3,37.78V80.49A13.89,13.89,0,0,0,16.84,94.36H83.16A13.89,13.89,0,0,0,97,80.49V37.78A13.89,13.89,0,0,0,83.16,23.91ZM16.84,28.64H83.16a9.15,9.15,0,0,1,9.14,9.14v3L59.84,50.69v-1.4A5.25,5.25,0,0,0,54.6,44H45.4a5.25,5.25,0,0,0-5.24,5.24v1.4L7.7,40.77v-3A9.15,9.15,0,0,1,16.84,28.64ZM55.11,49.29v9.2a.51.51,0,0,1-.51.51H45.4a.51.51,0,0,1-.51-.51v-9.2a.51.51,0,0,1,.51-.51h9.2A.51.51,0,0,1,55.11,49.29Zm28,40.34H16.84A9.15,9.15,0,0,1,7.7,80.49V45.72l32.45,9.92v2.85a5.25,5.25,0,0,0,5.24,5.24h9.2a5.25,5.25,0,0,0,5.24-5.24V55.64L92.3,45.72V80.49A9.15,9.15,0,0,1,83.16,89.63Z" />
            <path d="M35.91,22.89a2.37,2.37,0,0,0,2.37-2.37V13.76a3.39,3.39,0,0,1,3.39-3.39H58.34a3.39,3.39,0,0,1,3.39,3.39v6.76a2.37,2.37,0,0,0,4.73,0V13.76a8.13,8.13,0,0,0-8.12-8.12H41.66a8.13,8.13,0,0,0-8.12,8.12v6.76A2.37,2.37,0,0,0,35.91,22.89Z" />
          </g>
        </svg>
      ),
      title: 'Portare',
      description:
        'sempre con te i tuoi materiali didattici, grazie alla comodità del digitale: tutto a portata di clic ovunque tu sia.',
    },
    {
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
          <g>
            <path d="M50,12.61A37.39,37.39,0,1,0,87.39,50,37.43,37.43,0,0,0,50,12.61Zm0,70A32.61,32.61,0,1,1,82.61,50,32.65,32.65,0,0,1,50,82.61Z" />
            <path d="M69.68,47.61H52.39V30.32a2.39,2.39,0,1,0-4.78,0V52.39H69.68a2.39,2.39,0,0,0,0-4.78Z" />
          </g>
        </svg>
      ),
      title: 'Preparare',
      description:
        'le lezioni risparmiando tempo e sapendo di poterti fidare: le migliaia di materiali pronti all’uso sono di qualità certificata Giunti Scuola.',
    },
  ]
  const settings = {
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
  }

  return (
    <div className="iopiu2-help">
      <div className="iopiu2-help__content">
        <p className="iopiu2-help__title">Ancora dubbi?</p>
        <p className="iopiu2-help__description">Ti aiuteremo a:</p>
      </div>
      <div className="iopiu2-help__slider">
        <SlickSlider {...settings}>
          {items.map((item, i) => (
            <div className="iopiu2-help__slide" key={i}>
              <div className="iopiu2-help__slide__item">
                <div className="iopiu2-help__slide__icon">{item.icon}</div>
                <p className="iopiu2-help__slide__title">{item.title}</p>
                <p className="iopiu2-help__slide__description">{item.description}</p>
              </div>
            </div>
          ))}
        </SlickSlider>
      </div>
    </div>
  )
}

function IoPiu2Actions() {
  const context = useContext(CartContext)

  return (
    <div className="iopiu2-actions">
      <div className="iopiu2-actions__content">
        <p className="iopiu2-actions__title">Cosa aspetti?</p>
        <div className="iopiu2-actions__cta-box iopiu2-actions__cta-box--abbonati">
          <a
            className="button button--primary button--red iopiu2-actions__cta"
            target="_blank"
            onClick={() => {
              handleGTM('io_plus_annuale')
              context.addAbbonamentoToCart(8)
            }}
          >
            Abbonati a io+!
          </a>
        </div>
        <p className="iopiu2-actions__subtitle">Hai bisogno di maggiori informazioni?</p>
        <div className="iopiu2-actions__cta-box iopiu2-actions__cta-box--contattaci">
          <Link legacyBehavior href="/contatti">
            <a
              target="_blank"
              className="button button--primary button--black iopiu2-actions__cta"
              onClick={() => handleGTM('contatti')}
            >
              Contattaci
            </a>
          </Link>
        </div>
      </div>
    </div>
  )
}

function IoPiuTemplate() {
  const vantaggiRef = useRef(null)

  return (
    <main className="iopiu2-page">
      <IoPiu2Hero scrollRef={vantaggiRef} />
      <IoPiu2Options />
      <div ref={vantaggiRef}>
        <IoPiu2Vantaggi />
      </div>
      <IoPiu2Numeri />
      <IoPiu2Video />
      <IoPiu2Help />
      <IoPiu2Actions />
    </main>
  )
}

export default IoPiuTemplate
